import { GzAntimalwareDynamicThreatDefenseWebComponent } from './component/GzAntimalwareDynamicThreatDefenseWebComponent';

export { GzAntimalwareDynamicThreatDefenseWebComponent };
